<template>		
	<v-sheet color="transparent">
		<h2 class="cn-font light grey--text mb-6">{{title}}</h2>	
		<v-card color="white" tile class="pa-4 mb-5">
			<v-component :id="id" :is="form" :doc="doc" v-on:change="update"></v-component>
			<p class="text-right">
				<SaveSavingSaved class="mt-4" :status="status" @save="save"></SaveSavingSaved>
			</p>
		</v-card>
		<div v-for="panel in other_panels" :key="panel">
			<v-component :is="panel" :id="id" :collection="collection"></v-component>
		</div>
	</v-sheet>
</template>		
<script>
	import Vuex from "vuex"
	import SaveSavingSaved from "@/components/elements/SaveSavingSaved"
	export default {
		name: "Edit",
		props: ["title", "id", "collection", "form", "other_panels"], 
		data: () => {
			return {
				status: null,
				updated: {}
			}
		},
		components: {
			SaveSavingSaved,
			UserForm: () => import("@/components/forms/UserForm"),
			EditSurvey: () => import("@/components/survey/EditSurvey"),
			UserManagementButtons: () => import("@/components/admin/forms/UserManagementButtons")
		},
		computed: {
			...Vuex.mapState({
				docs(state){
					return state[this.collection] || []
				},
				state: state => state,
			}),
			doc(){ 
				var id = this.id;
				return this.docs.find( item => item.id == id )
			} 				
		},
		methods: {
			update(data){
				this.updated = data;
				this.status = "unsaved";
			},
			save() {
				this.status = "saving";
				var path = `${this.collection}/${this.id}`;
				this.$store.dispatch("updateDoc", {
					doc: path,
					data: this.updated,
					action: "update"
				}).then(() => {
					this.status = "saved"
				}).catch( error => {
					this.error = error;
					console.log(error)
					this.status = "error"
				})
			},
		},
		watch: {
			docs: {
				immediate: true, 
				handler(  ){
					if( !this.doc ){
						var module_loaded = this.$store.hasModule(this.collection);
						if( module_loaded){
							this.$store.dispatch(`${this.collection}/getOne`, this.id  )
						}
					}
				}
			}
		}
	}
</script>